export const setCharacters = (state, {characters}) => {
  state.characters = characters
}

export const setLoaded = (state, {loaded}) => {
  state.loaded = loaded
}

export const setItems = (state, {items}) => {
  state.items = items
}

export const selectCharacter = (state, {selectedCharacter}) => {
  state.selectedCharacter = selectedCharacter
}

export const setCharacterEquipment = (state, {characterEquipment}) => {
  state.characterEquipment = characterEquipment
}

export const setCharacterInventories = (state, {characterInventories}) => {
  state.characterInventories = characterInventories
}
export const setProfileInventory = (state, {profileInventory}) => {
  state.profileInventory = profileInventory
}

export const setItemComponents = (state, {itemComponents}) => {
  state.itemComponents = itemComponents
}

export const updateItemCharacter = (state, {item, newCharacterId}) => {
  state.items.find((searched) => searched.data.itemInstanceId === item.data.itemInstanceId).characterHash = newCharacterId
}

export const setUnequipped = (state, {item}) => {
  item.instance.isEquipped = false
}

export const setEquipped = (state, {item}) => {
  item.instance.isEquipped = true
}

export const setUnLocked = (state, {item}) => {
  item.data.state = 0
}

export const setLocked = (state, {item}) => {
  item.data.state = 1
}




// WEBPACK FOOTER //
// ./src/store/destiny/profile/mutations.js